/* eslint-disable */
import React, { useEffect, useState } from "react";
import "./styles.scss";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import CCarousel from "Common/CCarousel";
import fbIcon from "../../../assets/icon/fbIcon.svg";
import igIcon from "../../../assets/icon/igIcon.svg";
import ytIcon from "../../../assets/icon/youtubeIcon.svg";
import { sanitize } from "../../../Common/Util";

export default function Profile({ data, video: initialVideo, listVideo }) {
  const { i18n } = useTranslation();
  const [video, setVideo] = useState(initialVideo);

  useEffect(() => {
    setVideo(initialVideo);
  }, [initialVideo]);

  function getId(url) {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);

    return match && match[2].length === 11 ? match[2] : null;
  }

  return (
    <div className="profile-tab mb-8">
      {data?.name && (
        <div className="content">
          <div className="info">
            <div className="image artist-img">
              <img
                style={{ aspectRatio: "1/1" }}
                src={data?.image}
                alt={data?.name}
              />
            </div>
            <div className="details">
              <div className="name title-1">{data?.name}</div>
              <div className="contact-icon">
                <a href={data?.facebook_link} target="_blank" rel="noreferrer">
                  <img src={fbIcon} />
                </a>
                <a href={data?.youtube_link} target="_blank" rel="noreferrer">
                  <img style={{ maxWidth: 150 }} src={ytIcon} />
                </a>
                <a href={data?.instagram_link} target="_blank" rel="noreferrer">
                  <img src={igIcon} />
                </a>
              </div>
              <p className="dob normal-text">D.O.B: {data?.dob}</p>
              <p
                className="brief-introduction normal-text"
                dangerouslySetInnerHTML={sanitize(
                  i18n.language == "vi"
                    ? data?.description_VN
                    : data?.description_ENG,
                )}
              />
            </div>
          </div>
          <div className="music-release">
            <div className="title title-2">MUSIC RELEASE</div>
            <div className="video">
              <iframe
                src={`https://www.youtube.com/embed/${getId(
                  _.get(video, "link", ""),
                )}`}
                title="YouTube video player"
                // frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
          {/* <div className="production">
            <div className="title title-2">DISCOGRAPHY</div>
            <div className="product">
              {listVideo?.length > 0 && (
                <CCarousel>
                  {listVideo.map((value) => (
                    <div key={value.id} className="thumbnail-item">
                      <img
                        onClick={() => setVideo(value)}
                        src={_.get(value, "image", "")}
                        alt={_.get(value, "image")}
                      />
                    </div>
                  ))}
                </CCarousel>
              )}
            </div>
          </div> */}
        </div>
      )}
    </div>
  );
}
